import { urls } from 'routes/app';
import PayInvoice from 'pages/client/invoice/pay';

export const paths = [
    {
        path: urls.client.invoice,
        component: PayInvoice
    }
];
